function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "19",
  height: "17",
  viewBox: "0 0 19 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  opacity: ".5"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "1.873",
  cy: "1.873",
  transform: "rotate(-.334 48.32 -1296.195) skewX(-.001)",
  fill: "#fff",
  r: "1.873"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.51 2.258c-1.565.01-2.832.38-3.803 1.09-.973.714-1.518 1.674-1.809 2.625-.516 1.69-.276 3.556-.16 4.467l.024.182c.01.084.016.169.019.255l9.432-7.697c-.973-.617-2.205-.93-3.703-.922zm6.137 5.389l-9.985 8.149c1.033.203 2.443.408 3.929.4 1.498-.01 2.968-.235 4.046-.45.544-.109.998-.217 1.318-.3.134-.033.46-.12.524-.141a1.351 1.351 0 00.742-2.04l-.017-.028a4.942 4.942 0 01-.354-.75c-.196-.525-.355-1.213-.281-1.95l.01-.105c.065-.635.17-1.668.068-2.785zm-2.082 2.924a.75.75 0 01.739.761c-.01.653.03 1.383.318 1.885a.75.75 0 01-.288 1.03h-.002a3.65 3.65 0 01-.257.121c-.15.064-.363.145-.637.225a8.76 8.76 0 01-2.357.327.75.75 0 01-.016-1.5 7.29 7.29 0 001.928-.26c-.192-.693-.196-1.396-.189-1.85a.75.75 0 01.761-.74z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.8 15.721L17.634 2.798",
  stroke: "#fff",
  strokeWidth: "2",
  strokeLinecap: "round"
}))));